<template>
  <el-dialog
    class="partorder-statistic-modal"
    width="90%"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <template slot="title">
      <span class="el-dialog__title">
        <div>
          配件消费统计
          <a :href="`/order/list?buyerId=${companyId}`" style="font-size: 14px">订单列表</a>
        </div>
      </span>
    </template>
    <div v-loading="loading">
      <div class="actions">
        <el-select v-model="chartType" size="mini">
          <el-option :value="1" label="消费统计" />
          <el-option :value="2" label="月度变化" />
        </el-select>
        <el-date-picker v-model="startTime" value-format="yyyy-MM-dd" type="date" placeholder="开始时间" size="mini" />
        <el-date-picker v-model="endTime" value-format="yyyy-MM-dd" type="date" placeholder="结束时间" size="mini" />
        <el-button type="success" size="mini" @click="loadData">确定</el-button>
      </div>
      <div v-if="chartType===1" class="data-table">
        <div class="row header">
          <div class="td">
            品牌
          </div>
          <div class="td">
            消费
          </div>
          <div class="td">
            退款
          </div>
          <div class="td">
            合计
          </div>
        </div>
        <template v-if="pieData && pieData.length">
          <div v-for="br in pieData" :key="br.brandCode" class="row data">
            <div class="td">
              {{ br.brandCode }}
            </div>
            <div class="td">
              <div>
                {{ br.amountPay | currencyFmt }}<span class="sub-info">({{ br.count }}笔)</span>
                <span class="sub-info" v-if="br.amountOil">
                  [机油：{{ br.amountOil | currencyFmt }}]
                </span>
              </div>
              <div>急件：{{ br.amountPayJi | currencyFmt }}<span class="sub-info">({{ br.countJi }}笔)</span></div>
              <div>含税：{{ br.amountPayTax | currencyFmt }}<span class="sub-info">({{ br.countTax }}笔)</span></div>
            </div>
            <div class="td">
              <div>
                {{ br.amountReturn | currencyFmt }}<span class="sub-info">({{ br.countReturn }}笔)</span>
                <span class="sub-info" v-if="br.amountOilReturn">
                  [机油：{{ br.amountOilReturn | currencyFmt }}]
                </span>
              </div>
              <div>急件：{{ br.amountReturnJi | currencyFmt }}<span class="sub-info">({{ br.countReturnJi }}笔)</span></div>
              <div>含税：{{ br.amountReturnTax | currencyFmt }}<span class="sub-info">({{ br.countReturnTax }}笔)</span></div>
            </div>
            <div class="td">
              <div>
                {{ br.amountPay - br.amountReturn | currencyFmt }}
                <span class="sub-info" v-if="br.amountOil">
                  [机油：{{ br.amountOil - br.amountOilReturn | currencyFmt }}]
                </span>
              </div>
              <div>急件：{{ br.amountPayJi - br.amountReturnJi | currencyFmt }}</div>
              <div>含税：{{ br.amountPayTax - br.amountReturnTax | currencyFmt }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row no-data">
            暂无数据
          </div>
        </template>
      </div>
      <div v-else class="data-table">
        <div class="row header">
          <div class="td">
            月份
          </div>
          <div class="td">
            宝马系
          </div>
          <div class="td">
            奔驰系
          </div>
          <div class="td">
            路虎捷豹
          </div>
          <div class="td">
            大众系
          </div>
          <div class="td">
            通用系
          </div>
          <div class="td">
            其他
          </div>
        </div>
        <template v-if="lineData && lineData.length">
          <div v-for="pd in lineData" :key="pd.period" class="row data">
            <div class="td">
              {{ pd.period }}
            </div>
            <div class="td">
              <div>消费：{{ pd.amountBmw }}<span v-if="pd.orderBmwCount">({{ pd.orderBmwCount }}笔)</span></div>
              <div>退款：{{ pd.amountBmwReturn }}<span v-if="pd.orderBmwReturnCount">({{ pd.orderBmwReturnCount }}笔)</span></div>
              <div>净额：{{ pd.amountBmwRemain }}</div>
            </div>
            <div class="td">
              <div>消费：{{ pd.amountBenz }}<span v-if="pd.orderBenzCount">({{ pd.orderBenzCount }}笔)</span></div>
              <div>退款：{{ pd.amountBenzReturn }}<span v-if="pd.orderBenzReturnCount">({{ pd.orderBenzReturnCount }}笔)</span></div>
              <div>净额：{{ pd.amountBenzRemain }}</div>
            </div>
            <div class="td">
              <div>消费：{{ pd.amountLd }}<span v-if="pd.orderLdCount">({{ pd.orderLdCount }}笔)</span></div>
              <div>退款：{{ pd.amountLdReturn }}<span v-if="pd.orderLdReturnCount">({{ pd.orderLdReturnCount }}笔)</span></div>
              <div>净额：{{ pd.amountLdRemain }}</div>
            </div>
            <div class="td">
              <div>消费：{{ pd.amountVw }}<span v-if="pd.orderVwCount">({{ pd.orderVwCount }}笔)</span></div>
              <div>退款：{{ pd.amountVwReturn }}<span v-if="pd.orderVwReturnCount">({{ pd.orderVwReturnCount }}笔)</span></div>
              <div>净额：{{ pd.amountVwRemain }}</div>
            </div>
            <div class="td">
              <div>消费：{{ pd.amountGmw }}<span v-if="pd.orderGmwCount">({{ pd.orderGmwCount }}笔)</span></div>
              <div>退款：{{ pd.amountGmwReturn }}<span v-if="pd.orderGmwReturnCount">({{ pd.orderGmwReturnCount }}笔)</span></div>
              <div>净额：{{ pd.amountGmwRemain }}</div>
            </div>
            <div class="td">
              <div>消费：{{ pd.amountOther }}<span v-if="pd.orderOtherCount">({{ pd.orderOtherCount }}笔)</span></div>
              <div>退款：{{ pd.amountOtherReturn }}<span v-if="pd.orderOtherReturnCount">({{ pd.orderOtherReturnCount }}笔)</span></div>
              <div>净额：{{ pd.amountOtherRemain }}</div>
            </div>
          </div>
        </template>
        <div v-else class="row no-data">
          暂无数据
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { loadCustomerPartOrder, ListCusumerChange } from '../services'
export default {
  name: 'PartOrderStatisticsModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      companyId: undefined,
      startTime: undefined,
      endTime: undefined,
      chartType: 1,
      pieData: [],
      lineData: []
    }
  },
  watch: {
    chartType () {
      this.loadData()
    }
  },
  methods: {
    init (companyId) {
      this.companyId = companyId
      this.loadData()
      return this.open()
    },
    loadData () {
      this.loading = true
      if (this.chartType === 1) {
        loadCustomerPartOrder(this.companyId, this.startTime, this.endTime).then((resp) => {
          this.pieData = resp
        }).catch(() => {
          this.close(false)
        }).finally(() => {
          this.loading = false
        })
      } else {
        ListCusumerChange(this.companyId, this.startTime, this.endTime).then((resp) => {
          this.lineData = resp
        }).catch(() => {
          this.close(false)
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>
<style lang="stylus">
.partorder-statistic-modal
  .el-dialog
    color: #1F1F1F
    max-width 1024px
    .el-dialog__title
      display flex
      flex-direction row
      padding-right 30px
      justify-content space-between
      .el-date-editor
        width 110px
        margin-right 4px
      .el-button
        padding-left 8px
        padding-right 8px
    .el-dialog__body
      color: #1F1F1F
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      position relative
      display flex
      flex-direction column
      .actions
        display flex
        flex-direction row
        justify-content flex-startDay
        margin-bottom 8px
        >div
          margin-right 8px
      .data-chart
        height 320px
        width 100%
        position relative
        flex-shrink 0
      .data-table
        border-left 1px solid #d4d4d4
        border-top 1px solid #d4d4d4
        .row
          display flex
          flex-direction row
          line-height 1.6
          &.header
            background #e4e4e4
          &.no-data
            justify-content space-between
            border-bottom 1px solid #d4d4d4
            border-right 1px solid #d4d4d4
            line-height 120px
          .td
            flex 2
            padding 4px
            flex-shrink 0
            border-bottom 1px solid #d4d4d4
            border-right 1px solid #d4d4d4
            &:nth-child(1)
              flex: 0.9
      .sub-info
        color: #999
        padding-left: 6px
.order-line-tooltip
  width 200px
  padding 0 !important
  margin 0 !important
  border none
.order-pie-tooltip
  width 200px
  padding 0 !important
  margin 0 !important
  border none
  .date
    font-weight: 600
    line-height: 2.4
    text-align center
  .serie-item
    display: flex
    flex-direction: row
    flex-wrap: nowrap
    line-height: 2
    padding 0 10px
    justify-content: space-between
    border-top: 1px dashed #d4d4d4
    .serie-color-block
      background: var(--serie-color)
      width: 10px
      height: 10px
      margin-top: 9px
    >div
      &:nth-child(1)
        width: 16px
        flex-grow: 0
        flex-shrink: 0
      &:nth-child(2)
        flex-grow: 1
        text-align: left
      &:nth-child(3)
        text-align: right
        flex-grow: 1
</style>
